import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(0);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    const INITIAL_TIME = 3 * 3600 + 47 * 60 + 23; // 3h 47m 23s
    const RESET_TIME = 2 * 3600; // 2h
    const storedEndTime = localStorage.getItem('biox90_urgency_end');
    const now = Math.floor(Date.now() / 1000);
    let endTime;
    if (storedEndTime) {
      endTime = parseInt(storedEndTime, 10);
      if (endTime <= now) {
        endTime = now + RESET_TIME;
        localStorage.setItem('biox90_urgency_end', endTime.toString());
      }
    } else {
      endTime = now + INITIAL_TIME;
      localStorage.setItem('biox90_urgency_end', endTime.toString());
    }
    setTimeLeft(endTime - now);
    const timer = setInterval(() => {
      const currentNow = Math.floor(Date.now() / 1000);
      let newTimeLeft = endTime - currentNow;
      if (newTimeLeft <= 0) {
        endTime = currentNow + RESET_TIME;
        localStorage.setItem('biox90_urgency_end', endTime.toString());
        newTimeLeft = RESET_TIME;
      }
      setTimeLeft(newTimeLeft);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  if (!mounted) return null;
  const h = Math.floor(timeLeft / 3600).toString().padStart(2, '0');
  const m = Math.floor(timeLeft % 3600 / 60).toString().padStart(2, '0');
  const s = (timeLeft % 60).toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-gradient-to-r from-[#FF4757] to-[#FF6B81] text-white h-[44px] flex items-center justify-center px-4 shadow-[0_4px_20px_rgba(255,71,87,0.3)] animate-shake" data-id="element-759">
      <div className="text-xs sm:text-sm font-medium text-center flex items-center gap-1 sm:gap-2" data-id="element-760">
        <span className="hidden sm:inline" data-id="element-761">
          ⚠️ OFERTA DE LANZAMIENTO: Descuento del 99% finaliza en
        </span>
        <span className="sm:hidden" data-id="element-762">⚠️ Termina en:</span>
        <div className="flex gap-0.5 mx-1" data-id="element-763">
          <span className="font-display font-bold bg-black/20 px-1 rounded" data-id="element-764">
            {h}
          </span>
          :
          <span className="font-display font-bold bg-black/20 px-1 rounded" data-id="element-765">
            {m}
          </span>
          :
          <span className="font-display font-bold bg-black/20 px-1 rounded" data-id="element-766">
            {s}
          </span>
        </div>
        <span className="hidden md:inline" data-id="element-767">
          . Solo quedan{' '}
          <span className="text-brand-gold font-bold" data-id="element-768">23 unidades</span>.
        </span>
        <span className="md:hidden text-brand-gold font-bold" data-id="element-769"> (23 left)</span>
      </div>
    </div>;
}